export default __webpack_public_path__ + "static/sample-35b2a28947bcdb5e234e87bc1d129362.jpg";